import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Page from '../../page.jsx';
import SuggestDifferentResolution from '../../resolution/suggestDifferentResolution.jsx';
import partnerPropTypes from '../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../paymentPropTypes.js';
import { trackEvent } from '../../../services/trackingService.js';

function discountSuggestionExists(payment = {}) {
    return !!payment.discount;
}

class HandleDefectItemPage extends PureComponent {
    componentDidMount() {
        trackEvent(
            'trade.buyer-does-not-approve-item.item-has-defects',
            'start'
        );
    }

    render() {
        const { partner, payment } = this.props;

        if (discountSuggestionExists(payment)) {
            return (
                <Page heading="Foreslå en annen løsning">
                    <SuggestDifferentResolution payment={payment} />
                </Page>
            );
        }

        return (
            <Page heading="Foreslå en løsning">
                <div>
                    <p>{partner.name} og du må bli enige om en løsning.</p>

                    <div className="centerify">
                        <div className="r-phl r-ptl">
                            <Link
                                className="button fullwidth"
                                to="/losning/foresla-avslag"
                            >
                                Prisavslag
                            </Link>

                            <div className="mtl">
                                <a
                                    target="_blank"
                                    href="https://hjelpesenter.finn.no/hc/no/articles/115001246405/"
                                >
                                    Les mer om prisavslag og retur
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

HandleDefectItemPage.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
        payment: state.payment.data,
    };
}

export default connect(mapStateToProps)(HandleDefectItemPage);



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/handleDefectItemPage.jsx